const getAnimationPngPath = require.context(
  '../../assets/photo/letter-number-formations/draw-stage',
  false,
  /.png$/
);

const AnimationImagePaths = {
  frogJump: [getAnimationPngPath('./frog-jump.png')],
  diveDown: [getAnimationPngPath('./dive-down.png')],
  diveDownDeep: [getAnimationPngPath('./dive-down.png')],
  bump: [getAnimationPngPath('./bump.png')],
  bumpInner: [getAnimationPngPath('./bump.png')],
  baseball: [
    getAnimationPngPath('./baseball.png'),
    getAnimationPngPath('./baseball-player.png'),
  ],
  helicopter: [getAnimationPngPath('./helicopter.png')],
  highHelicopter: [getAnimationPngPath('./helicopter.png')],
  jet: [getAnimationPngPath('./jet.png')],
  karateKick: [getAnimationPngPath('./karate-kick.png')],
  magicC: [getAnimationPngPath('./magic-c.png')],
  slideAway: [getAnimationPngPath('./slide-away.png')],
  slideDown: [getAnimationPngPath('./slide-down.png')],
  slideDownReversed: [getAnimationPngPath('./slide-down.png')],
  firefighter: [
    getAnimationPngPath('./firefighter.png'),
    getAnimationPngPath('./pole.png'),
  ],
  smile: [getAnimationPngPath('./smile.png')],
  swim: [getAnimationPngPath('./swim.png')],
  longSwim: [getAnimationPngPath('./swim.png')],
  tow: [getAnimationPngPath('./tow.png')],
};
export default AnimationImagePaths;
